import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import '../styles/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import formatMoney from '../../../utils/functions/formatMoneyBRL';
import { balancesFetchAction } from '../../../store/fetchActions/balancesActions';
import { useLocation } from 'react-router-dom';
export default function AvailableBalance() {
  let cpfcnpj = localStorage.getItem('cpfcnpj');
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    if (location !== '/login') dispatch(balancesFetchAction(cpfcnpj));
  }, [location]);

  const { saldoContaDigital } = useSelector((state) => state.balances);
  const [showBalance, setShowBalance] = useState(false);

  return (
    <div className="userBalanceContainer">
      <div>
        <h4>Saldo Conta Digital</h4>
      </div>
      {showBalance ? (
        <div className="userBalanceValue">
          <h5>R$ {formatMoney(saldoContaDigital)}</h5>
          <AiFillEye onClick={() => setShowBalance(!showBalance)} />
        </div>
      ) : (
        <div className="userBalanceValue">
          <h4>
            <Skeleton animation={false} />
          </h4>
          <AiFillEyeInvisible onClick={() => setShowBalance(!showBalance)} />
        </div>
      )}
    </div>
  );
}
